import { template as _$template } from "solid-js/web";
import { delegateEvents as _$delegateEvents } from "solid-js/web";
import { effect as _$effect } from "solid-js/web";
import { createComponent as _$createComponent } from "solid-js/web";
import { insert as _$insert } from "solid-js/web";
var _tmpl$ = /*#__PURE__*/_$template(`<p class=tapes__error data-testid=tape-shelf-error>`),
  _tmpl$2 = /*#__PURE__*/_$template(`<ul class=tapes__list>`),
  _tmpl$3 = /*#__PURE__*/_$template(`<section class=tapes data-testid=tape-shelf><header class=tapes__header><h1 class=tapes__title>MISSION RECORDER</h1><p class=tapes__subtitle>SELECT TAPE TO VIEW:</p></header><footer class=tapes__footer><label class=tapes__import>LOAD NEW TAPE<input type=file accept=.json,application/json data-testid=tape-import></label><button type=button class=tapes__button data-testid=tape-shelf-exit>EXIT`),
  _tmpl$4 = /*#__PURE__*/_$template(`<p class=tapes__empty data-testid=tape-shelf-empty>NO TAPES. FLY A MISSION AND SAVE IT WHEN THE DEBRIEFING ASKS, OR LOAD A TAPE FILE BELOW.`),
  _tmpl$5 = /*#__PURE__*/_$template(`<ul class=tapes__reasons>`),
  _tmpl$6 = /*#__PURE__*/_$template(`<li class=tapes__row data-testid=tape-row><div class=tapes__row-main><span class=tapes__name></span><span class=tapes__mission></span><span class=tapes__length></span><span class=tapes__date></span></div><div class=tapes__row-actions><button type=button class="tapes__button tapes__button--primary"data-testid=tape-load>LOAD</button><button type=button class=tapes__button>EXPORT</button><button type=button class=tapes__button>DELETE`),
  _tmpl$7 = /*#__PURE__*/_$template(`<li>`);
import { For, Show } from "solid-js";
import { locationCounter } from "./playback-speed.ts";
/**
 * `SELECT TAPE TO VIEW:` — the original's tape picker, which offered a
 * scrollable list of `*.VCR`, a filename field, and `CANCEL` / `LOAD`
 * (docs/game/ui-reference/mission-recorder-tapes.png). Its Tapes panel added
 * `LOAD NEW TAPE`, `SAVE CURRENT TAPE`, `DELETE TAPE(S)` and `DONE`.
 *
 * `SAVE CURRENT TAPE` has no counterpart here and should not: it belonged to
 * Director mode, where playback edits were held in memory and had to be written
 * back. Nothing in this port edits a tape — a recording is what was flown, and
 * the honest way to get a different flight is to fly one. `DELETE` and the two
 * halves of `LOAD` (from the shelf, or from a file) are all real.
 *
 * A tape this build can no longer replay stays on the shelf, greyed, with the
 * guard's own sentence under it. That is the whole point of the version guard
 * being polite: a stale tape is still a record of a flight, still exportable,
 * and still worth being told the truth about.
 */
export function TapeShelf(props) {
  return (() => {
    var _el$ = _tmpl$3(),
      _el$2 = _el$.firstChild,
      _el$5 = _el$2.nextSibling,
      _el$6 = _el$5.firstChild,
      _el$7 = _el$6.firstChild,
      _el$8 = _el$7.nextSibling,
      _el$9 = _el$6.nextSibling;
    _$insert(_el$, _$createComponent(Show, {
      get when() {
        return props.error;
      },
      get children() {
        var _el$3 = _tmpl$();
        _$insert(_el$3, () => props.error);
        return _el$3;
      }
    }), _el$5);
    _$insert(_el$, _$createComponent(Show, {
      get when() {
        return props.tapes.length > 0;
      },
      get fallback() {
        return _tmpl$4();
      },
      get children() {
        var _el$4 = _tmpl$2();
        _$insert(_el$4, _$createComponent(For, {
          get each() {
            return props.tapes;
          },
          children: tape => (() => {
            var _el$1 = _tmpl$6(),
              _el$10 = _el$1.firstChild,
              _el$11 = _el$10.firstChild,
              _el$12 = _el$11.nextSibling,
              _el$13 = _el$12.nextSibling,
              _el$14 = _el$13.nextSibling,
              _el$16 = _el$10.nextSibling,
              _el$17 = _el$16.firstChild,
              _el$18 = _el$17.nextSibling,
              _el$19 = _el$18.nextSibling;
            _$insert(_el$11, () => tape.name);
            _$insert(_el$12, () => tape.title);
            _$insert(_el$13, () => locationCounter(tape.ticks));
            _$insert(_el$14, () => tape.recordedAt.slice(0, 10));
            _$insert(_el$1, _$createComponent(Show, {
              get when() {
                return !tape.playable;
              },
              get children() {
                var _el$15 = _tmpl$5();
                _$insert(_el$15, _$createComponent(For, {
                  get each() {
                    return tape.reasons;
                  },
                  children: reason => (() => {
                    var _el$20 = _tmpl$7();
                    _$insert(_el$20, reason);
                    return _el$20;
                  })()
                }));
                return _el$15;
              }
            }), _el$16);
            _el$17.$$click = () => props.onLoad(tape.name);
            _el$18.$$click = () => props.onExport(tape.name);
            _el$19.$$click = () => props.onDelete(tape.name);
            _$effect(_p$ => {
              var _v$ = !tape.playable,
                _v$2 = !tape.playable;
              _v$ !== _p$.e && _el$1.classList.toggle("tapes__row--stale", _p$.e = _v$);
              _v$2 !== _p$.t && (_el$17.disabled = _p$.t = _v$2);
              return _p$;
            }, {
              e: undefined,
              t: undefined
            });
            return _el$1;
          })()
        }));
        return _el$4;
      }
    }), _el$5);
    _el$8.addEventListener("change", event => {
      const file = event.currentTarget.files?.[0];
      // Cleared so picking the same file twice in a row fires again —
      // a change event only fires when the value actually changes.
      event.currentTarget.value = "";
      if (file) props.onImport(file);
    });
    _el$9.$$click = () => props.onExit();
    return _el$;
  })();
}
_$delegateEvents(["click"]);